import {createFeatureSelector, createSelector} from '@ngrx/store';
import {ResearchPaperState} from './research-paper.reducer';
import {selectQueryParam} from '../../../../utils/services/router.selectors';
import {ResearchPaperDTO} from '../../dto/research-paper';

export const selectResearchPaperState = createFeatureSelector<ResearchPaperState>('researchPapers');

export const selectPapersByProjectId = (projectId: number) =>
  createSelector(selectResearchPaperState, (state) => state.papersByProject[projectId] || []);

export const selectHasPapersByProjectId = (projectId: number) =>
  createSelector(selectResearchPaperState, (state) => (state.papersByProject[projectId] || []).length > 0 || false);

export const selectPapers = () =>
  createSelector(selectResearchPaperState, (state) => state.papersByProject || []);


export const selectPaperByProjectId = (projectId: number, paperId: number) =>
  createSelector(selectPapersByProjectId(projectId), (state) => state.filter(p => p.id === paperId)[0] || undefined);


export const selectRoutePaperByProjectId = (projectId: number) =>
  createSelector(selectPapersByProjectId(projectId), selectQueryParam("paper"), (papers: ResearchPaperDTO[], paperId) => paperId ? papers.filter(p => p.id === +paperId).shift() : undefined);


export const selectPapersByProjectIdAndPaperId = (projectId: number, paperId: number) =>
  createSelector(selectPapersByProjectId(projectId),
    (state) => state.filter(p => p.id === paperId).shift() || undefined);


export const selectErrorByProjectId = (projectId: number) =>
  createSelector(selectResearchPaperState, (state) => state.errorByProject[projectId] || null);

export const selectLoading = () =>
  createSelector(selectResearchPaperState, (state) => state.loading || false);

export const selectSelectedResearchPaper = createSelector(
  selectResearchPaperState,
  (state) => state.selectedPaper
);

export const isScreeningRunning = createSelector(
  selectResearchPaperState,
  (state) => state.screeningRunning
);


export const selectPapersByProjectIdAndQueryId = (projectId: number, queryId: number) =>
  createSelector(selectPapersByProjectId(projectId),
    (state) => state.filter(p => p.queryIds && p.queryIds.includes(queryId)) || []);


export const selectPapersSearched = (projectId: number) =>
  createSelector(selectResearchPaperState, (state) => state.searched[projectId] || false);



